export default __webpack_public_path__ + "static/media/lekalo-icon.264841ee.svg";